import moment from 'moment';
import React, { Component } from 'react';
import '../css/formats.css';
import { development } from "../libs/utils/Const";

class FormatCancelationModal extends Component {

    render() {
        const {  DocHeader, InfoByFolio } = this.props;
        return (

            <div>
                <div className='mt-5' style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto" }}>
                    <div className="row">
                        <div className="col-3">
                            <img src={development? require('../images/logo_draft.svg') : require('../images/logo_EMPRESA.svg')} alt="Logo" />
                        </div>
                        <div className="col-6 text-center">
                            <h4><strong>Acuse de cancelación</strong></h4>
                        </div>
                        <div className="col-3">
                        </div>
                    </div>
                    <br />
                    <div className='row mt-3'>
                        <div className='col-4'>
                            <span>Usuario: </span>
                            <span>{DocHeader && DocHeader.CardCode}</span><br />
                            <span>{DocHeader && DocHeader.CardName}</span>
                        </div>
                        <div className='col-2'></div>
                        <div className='col-3'>
                            <span>CC0 JARIPILLO</span>
                        </div>
                        <div className='col-2'></div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-12'>
                            <span><strong>Fecha y hora de solicitud: </strong>{DocHeader && moment(DocHeader.DocDate).format("YYYY-MM-DD")}</span><br />
                            <span><strong>Fecha y hora de cancelación: </strong>{!!InfoByFolio ?  InfoByFolio.docTime.toString().length > 4 ? InfoByFolio.docTime : moment(InfoByFolio.docTime).format('LT') : ''}</span><br />
                            <span><strong>RUT Emisor: </strong>{DocHeader && DocHeader.LicTradNum}</span>
                        </div>
                    </div>
                    <div className='row mt-3' style={{ paddingRight: "15px" }}>
                        <div className='col-12'>
                            <table style={{ border: "solid 1px" }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: "12vw" }}></th>
                                        <th className="text-center" >Folio Fiscal</th>
                                        <th className="text-center">Estado CFDI</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th style={{ width: "12vw" }}></th>
                                        <td className="text-center ml-3 mr-3">9176B43B6-704C-42C6-9A87-C954354C00DD</td>
                                        <td className="text-center ml-3 mr-3" style={{ fontStyle: "italic" }}>Cancelado</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td colSpan="3" style={{ paddingLeft: "15px" }}><strong>Sello digital del SAT:</strong></td>

                                    </tr>
                                    <tr>
                                        <td colSpan="3" style={{ overflowWrap: "break-word", padding: "15px" }}>
                                            QAJa5A4cTTC3osVywJWDcnC11Ylg1d8+lB85xqZsVzPnaVIn+Bg5PxA89+2w30SIW3pvtrnbKhfmQvrrhP/L8Dkm7l+PgygShgq4bYPuon0
                                            Qxbw3npMXtA19/dLvohwR2D8OVeEYdutEWS7tCnEQlEy8lEF3s4xhHqh7zwJV60jTTCV0uYfI3Rf/Z/gynq2pQyC2Zj/KgDmVYX26eYXR7M
                                            A0Mk1hAs7gHUhcr8/UxGwhFpZj4JDTh6MhiORs+zBq/lZ+xnrLVea6qOr9MIi0QUK8VaScMwNHSZ9UtZjMF8dGm48lkfTk2ivN/dWjQ1cPj
                                            pQ==
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FormatCancelationModal;